<template>
  <div
    data-aos="zoom-out"
    :data-aos-delay="150 * index"
    data-aos-duration="500"
    class="event-card-wrap"
    :class="classObject"
    v-match-heights="{
      el: ['.event-card-wrap', '.card-title', '.date', '.anchor-link']
    }"
  >
    <div class="img-wrap">
      <img :src="item.image" alt="Cover" />
    </div>
    <div class="card-body">
      <div class="date">
        {{ item.date }}
      </div>
      <div class="card-title">
        {{ item.title }}
      </div>
      <div class="anchor-link">
        <a :href="item.anchor ? item.anchor : ''" target="_blank">
          Read More
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventCard",
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    extraClass: {
      type: [String, Array]
    }
  },
  computed: {
    classObject() {
      return this.extraClass ? this.extraClass : "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.event-card-wrap {
  position: relative;
  padding: 15px;
  background: #ffffff;
  @include boxShadow(0px, 3px, 6px, 0px, rgba(0, 0, 0, 0.16));
  transition: all 0.2s ease-in;
  .card-body {
    padding-top: 35px;
    .date {
      font-family: $content-font;
      color: #000;
      font-size: 12px;
      margin-bottom: 5px;
      font-weight: 500;
    }
    .card-title {
      font-family: $content-font;
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      color: #212164;
      text-transform: uppercase;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .anchor-link {
      margin-top: 20px;
      a {
        font-family: $content-font;
        color: $brand-color;
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
  &:hover {
    transform: translateY(-5px);
    @include boxShadow(0px, 5px, 20px, 3px, rgba(0, 0, 0, 0.2));
  }
  &.side-image {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .img-wrap {
      width: 100px;
      height: 100px;
    }
    .card-body {
      width: calc(100% - 100px);
      padding: 0px 0 0 15px;
      .anchor-link {
        margin-top: 10px;
      }
    }
  }
  &.text-center {
    .card-body {
      text-align: center;
    }
  }
}
</style>
